import axios from "axios";

const api = axios.create({
  //baseURL: "https://inteagro-node-923295720729.southamerica-east1.run.app",
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("inteagro_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;